module.exports = __webpack_public_path__ + "static/media/arrow.c97cc055.svg";